import React, { Component } from 'react'
import { getBranchesLatest } from '../../store/actions';
import moment from 'moment';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetCalendar from '../../classetComponents/classetCalender';
import Authentication from '../../session';
import { connect } from 'react-redux';
import withRouter from '../lib/withRouter';
import { BasicLazyParams } from '../../utile';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import * as XLSX from 'xlsx';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';

const dateRangeOptions = [
    { value: 1, label: "Today" },
    { value: 2, label: "Yesterday" },
    { value: 3, label: "This Week" },
    { value: 4, label: "Last Week" },
    { value: 5, label: "This Month" },
    { value: 6, label: "Last 3 Months" },
    { value: 7, label: "Academic Session" },
    { value: 8, label: "Custom" }
];

class unassignReports extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dropdownsData: {},
            lazyParams: BasicLazyParams,
            feeUnassignReport: [],
            filteredData: [],
            currentData: [],
            dateRangeType: null,
            startDate: null,
            endDate: null,
            isLoading: false
        }
        this.service = new Service()
    }
    componentDidMount() {
        // this.props.getBranchesLatest(true)
        this.getFeeUnassignReportInfo();
    }

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData,
        }, () => {
            if (this.state.dropdownsData?.sectionIds) {
                this.applyAllFilters();

            }
        });
    }

    getFeeUnassignReportInfo = async () => {
        let { lazyParams, globalSearch } = this.state;
        this.setState({
            isLoading: true,
        });
        let url = `${baseUrlAdmin}/financeReports/feeUnassignReport?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;
        let payload = {
            academicYear: localStorage.getItem('userAcademicYear'),
            boardIds: this.state.dropdownsData.boardIds,
            classIds: this.state.dropdownsData.classIds,
            branchIds: this.state.dropdownsData.branchIds,
            sectionIds: this.state.dropdownsData.sectionIds,
            dateRangeType: this.state.dateRangeType,
        }
        this.service.post(url, payload, true).then(data => {
            if (data.status && data?.res?.status) {
                this.setState({
                    feeUnassignReport: data?.res?.data,
                    filteredData: data?.res?.data,
                    totalRecords: data?.res?.totalRecords,
                    isLoading: false
                }, () => {
                    this.applyAllFilters();
                });
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    filterByDateRange = (data, dateRangeType) => {
        const today = moment();

        switch (dateRangeType) {
            case 1: // Today
                return data.filter(item =>
                    moment(item.createdAt).isSame(today, 'day')
                );
            case 2: // Yesterday
                return data.filter(item =>
                    moment(item.createdAt).isSame(today.clone().subtract(1, 'day'), 'day')
                );
            case 3: // This Week
                return data.filter(item =>
                    moment(item.createdAt).isSame(today, 'week')
                );
            case 4: // Last Week
                return data.filter(item =>
                    moment(item.createdAt).isSame(today.clone().subtract(1, 'week'), 'week')
                );
            case 5: // This Month
                return data.filter(item =>
                    moment(item.createdAt).isSame(today, 'month')
                );
            case 6: // Last 3 Months
                return data.filter(item =>
                    moment(item.createdAt).isAfter(today.clone().subtract(3, 'months'))
                );
            case 7: // Academic Session
                return data;
            case 8: // Custom date range
                const { startDate, endDate } = this.state;
                if (startDate && endDate) {
                    return data.filter(item =>
                        moment(item.createdAt).isBetween(startDate, endDate, 'day', '[]')
                    );
                }
                return data;
            default:
                return data;
        }
    };

    applyAllFilters = () => {
        const { feeUnassignReport, dropdownsData, dateRangeType, lazyParams, globalFilter } = this.state;
        let filtered = [...feeUnassignReport];

        // Apply dropdown filters
        if (dropdownsData.sectionIds?.length) {
            filtered = filtered.filter(item =>
                dropdownsData.sectionIds.includes(item.sectionId[0])
            );
        }

        // Apply date range filter
        if (dateRangeType) {
            filtered = this.filterByDateRange(filtered, dateRangeType);
        }

        // Apply global filter
        if (globalFilter) {
            const searchValue = globalFilter.toLowerCase();
            filtered = filtered.filter(item =>
                (item.enrollmentId && item.enrollmentId.toLowerCase().includes(searchValue)) ||
                (item.firstName && item.firstName.toLowerCase().includes(searchValue)) ||
                (item.lastName && item.lastName.toLowerCase().includes(searchValue)) ||
                (item.branchName && item.branchName.toLowerCase().includes(searchValue)) ||
                (item.boardName && item.boardName.toLowerCase().includes(searchValue)) ||
                (item.className && item.className.toLowerCase().includes(searchValue)) ||
                (item.sectionName && item.sectionName.toLowerCase().includes(searchValue)) ||
                (item.feeType && item.feeType.toLowerCase().includes(searchValue))
            );
        }

        // Apply pagination
        const first = lazyParams.first || 0;
        const rows = lazyParams.rows || 10;
        const paginatedData = filtered?.slice(first, first + rows);

        this.setState({
            filteredData: paginatedData,
            totalRecords: filtered.length
        });
    }

    onPage = (event) => {
        const lazyParams = { ...this.state.lazyParams };
        lazyParams.first = event.first;
        lazyParams.rows = event.rows;
        lazyParams.page = event.page;

        this.setState({ lazyParams }, () => {
            // For client-side pagination with filtered data
            this.applyAllFilters();
        });
    }

    handleDateRangeChange = (value) => {
        // Reset custom date range when changing date type
        const newState = { dateRangeType: value };

        if (value !== 8) {
            newState.startDate = null;
            newState.endDate = null;
        }

        this.setState(newState, () => {
            this.applyAllFilters();
        });
    }

    handleGlobalFilterChange = (e) => {
        const value = e.target.value;
        const lazyParams = { ...this.state.lazyParams };

        // Reset to first page when searching
        lazyParams.first = 0;
        lazyParams.page = 0;

        this.setState({
            lazyParams,
            globalFilter: value
        }, () => {
            // If you want server-side filtering, call the API here
            // For client-side, use applyAllFilters
            this.applyAllFilters();
        });
    }

    exportToExcel = () => {
        const { feeUnassignReport } = this.state;
        const dataToExport = feeUnassignReport;

        // Transform data for Excel
        const excelData = dataToExport.map(item => ({
            'Student Id': item.enrollmentId || '',
            'Student Name': `${item.firstName || ''} ${item.lastName || ''}`,
            'Branch': item.branchName || '',
            'Board': item.boardName || '',
            'Class-Section': `${item.className || ''}-${item.sectionName || ''}`,
            'Request From': `${item?.adminUserName?.slice(3) || ''}`,
            'Request Date': item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : '-',
            'Fee Type': item.feeType || '',
            'Fee Amount': item.totalAmount ? (item.totalAmount).toFixed(2) : '0',
            'Approved By': item.handledBy?.length > 0 ? item.handledBy[item.handledBy.length - 1]?.userName?.slice(3) : '',
            'Approved Remarks': item.handledBy?.length > 0 ? item.handledBy[item.handledBy.length - 1]?.remarks : '',
            'Approved Date': item.handledBy?.length > 0 ? moment(item.handledBy[item.handledBy.length - 1]?.handledDate).format('DD/MM/YYYY') : '-'
        }));

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Fee Unassignment Report');

        // Generate filename with date
        const fileName = `FeeUnassignmentReport_${moment().format('DDMMYYYY')}.xlsx`;

        // Save file
        XLSX.writeFile(wb, fileName);
    };

    render() {
        return (
            <>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    padding: '0',
                    marginLeft: "100px",
                    marginTop: "60px",
                    overflow: 'auto',

                }}>
                    <div className="card filters-card mt-1 pt-0">
                        {/* First Row - Branch Section */}
                        <div className="flex mb-4">
                            <div className="col-12">
                                <BranchToSectionMultiDDTillSecReports setValues={this.setDropdownValues} />
                            </div>
                        </div>

                        {/* Second Row - Buttons */}
                        {/* Date Range Selection Row */}
                        {/*     <div className="flex mb-4">
                            <div className="col-4">
                                <ClassetDropdown
                                    label="Date Range"
                                    options={dateRangeOptions}
                                    value={this.state.dateRangeType}
                                    onChange={(e) => this.handleDateRangeChange(e.value)}
                                    placeholder="Select Date Range"
                                />
                            </div>
                            {this.state.dateRangeType === 8 && (
                                <>
                                    <div className="col-4">
                                        <ClassetCalendar
                                            label="Start Date"
                                            value={this.state.startDate}
                                            onChange={(e) => this.setState({ startDate: e.value }, this.applyAllFilters)}
                                            showIcon={true}
                                        />
                                    </div>
                                    <div className="col-4">
                                        <ClassetCalendar
                                            label="End Date"
                                            value={this.state.endDate}
                                            onChange={(e) => this.setState({ endDate: e.value }, this.applyAllFilters)}
                                            showIcon={true}
                                        />
                                    </div>
                                </>
                            )}
                        </div> */}

                        <div className="flex justify-content-end">
                            {/* Action Buttons */}
                            <div className="flex gap-3">
                                <Button
                                    label="Download Report"
                                    onClick={this.exportToExcel}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                />
                                <Button
                                    label="View Analysis"
                                    className="p-button-primary"
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff" }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='datatable-report-demo mx-2'>
                        <DataTable
                            value={this.state.filteredData}
                            dataKey="id"
                            paginator
                            lazy
                            responsiveLayout="scroll"
                            columnResizeMode="expand"
                            resizableColumns
                            onPage={(e) => this.onPage(e)}
                            first={this.state.lazyParams.first}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            globalFilter={this.state.globalFilter}
                            onGlobalFilterChange={(e) => this.handleGlobalFilterChange(e)}
                        >

                            <Column field="" header="Student Id"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData.enrollmentId}
                                        </p>
                                    )
                                }}
                            />
                            <Column filterField="firstName" field="" header="Student Name"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.firstName} {rowData?.lastName}
                                        </p>
                                    )
                                }}
                            />

                            <Column filterField="branchName" field="username" header="Branch"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.branchName}
                                        </p>
                                    )
                                }} />
                            <Column filterField="boardName" header="Board"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.boardName}
                                        </p>
                                    )
                                }} />
                            <Column filterField="className" field="username" header="Class-Section"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.className + "-" + rowData?.sectionName}
                                        </p>
                                    )
                                }} />
                            <Column filterField="className" field="username" header="Request From"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.adminUserName ? rowData.adminUserName?.slice(3) : ''}
                                        </p>
                                    )
                                }} />
                            <Column
                                header="Request Date"

                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.createdAt ? moment(rowData.createdAt).format('DD/MM/YYYY') : '-'}
                                        </p>
                                    )
                                }}
                            />
                            <Column field="username" header="Fee Type"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.feeType}
                                        </p>
                                    )
                                }}
                            />
                            <Column field="username" header="Fee Amount"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.totalAmount ? (rowData?.totalAmount).toFixed(2) : 0}
                                        </p>
                                    )
                                }}
                            />
                            <Column filterField="approvedBy" field="username" header="Approved By"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.handledBy?.length > 0 ? rowData.handledBy[rowData.handledBy.length - 1]?.userName?.slice(3) : ''}
                                        </p>
                                    )
                                }} />
                            <Column filterField="approvedRemarks" field="username" header="Approved Remarks"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.handledBy?.length > 0 ? rowData.handledBy[rowData.handledBy.length - 1]?.remarks : ''}
                                        </p>
                                    )
                                }} />
                            <Column filterField="" field="approvedDate" header="Approved Date"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>

                                            {rowData?.handledBy?.length > 0 ? moment(rowData.handledBy[rowData.handledBy.length - 1]?.handledDate).format('DD/MM/YYYY') : '-'}
                                        </p>
                                    )
                                }} />


                        </DataTable>
                    </div>
                </div>
                {this.state.isLoading && <LoadingComponent />}
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>
        )
    }
}
const mapStateToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStateToProps, {
    getBranchesLatest
})(Authentication(withRouter(unassignReports)));

